module.exports = __webpack_public_path__ + "static/media/logo.12860d64.png";